module.exports = __webpack_public_path__ + "static/yalda-harley-d8c858611937d0ae23c6ed5d27fa4bfd.jpg";